<template>
  <label
    class="v2-checkbox"
    :class="{ 'v2-checkbox--disabled': disabled }"
  >
    <input
      type="checkbox"
      class="v2-checkbox__input"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    >
    <span class="v2-checkbox__box">
      <svg
        v-if="value"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
    <span
      v-if="label"
      class="v2-checkbox__label"
    >{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'V2Checkbox',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.v2-checkbox {
  display: inline-flex;
  align-items: center;
  gap: var(--v2-space-2);
  cursor: pointer;
  user-select: none;

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  // Glass box — surface-2 (~2.5% black tint) + blur, so the unchecked
  // box reads as visibly translucent glass instead of opaque white. The
  // border (glass-stroke-strong for definition) gives it shape against
  // any substrate. Checked state stays solid violet for clear affordance.
  &__box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    border: 1.5px solid var(--v2-glass-stroke-strong);
    border-radius: var(--v2-radius-sm);
    // Translucent fill, no `backdrop-filter` — checkboxes appear in
    // filter lists and forms with many at once; per-checkbox blur on a
    // 16px box is GPU-expensive for ~zero visual benefit.
    background: var(--v2-glass-surface-2);
    color: var(--v2-primary-foreground);
    transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
    flex-shrink: 0;
  }

  &:hover &__box:not(.v2-checkbox--disabled &) {
    border-color: var(--v2-primary);
  }

  &__input:checked + &__box {
    background: var(--v2-primary);
    border-color: var(--v2-primary);
  }

  &__input:focus + &__box {
    box-shadow: 0 0 0 3px oklch(0.62 0.21 295 / 0.25);
    border-color: var(--v2-primary);
  }

  &__label {
    font-size: 0.875rem;
    color: var(--v2-foreground);
  }
}
</style>
